import React, { useEffect, useState } from "react";
import ProductDetails from "../pages/ProductDetails";
import BackClick from "../components/BackClick";
import { useSelector } from "react-redux";
import ProfileHeaderSlider from "../components/Header-Slider/ProfileHeaderSlider";
import { Breadcrumbs, Typography } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Link, useNavigate } from "react-router-dom";
import HeaderSlider from "../components/Header-Slider/HeaderSlider";
import BreadCrums from "../components/Breadcrums/BreadCrums";
import HeaderMainNavigation from "./HeaderMainNavigation";

function CommonProductDt() {
  const [cartLength, setCartLength] = useState(0);
  const navigate = useNavigate();
  const userid = useSelector((state) => state.fetchUser?.user?.id);
  const cart =
    useSelector((state) => state.fetchCart?.cartInfo?.cartItem) || [];

  const updateCartLength = () => {
    setCartLength(cart.filter((item) => item.storeid === userid).length);
  };

  useEffect(() => {
    updateCartLength();
  }, [cart]);

  const prevhandler = () => {
    navigate(-1);
  };

  return (
    <>
      {/* <ProfileHeaderSlider /> */}
      <HeaderSlider />
      <HeaderMainNavigation />
      <BreadCrums/>
      <BackClick showmenu={true} cartLength={cartLength} />
      <ProductDetails cartLength={cartLength} setCartLength={setCartLength} />
    </>
  );
}

export default CommonProductDt;
